import { Map } from 'immutable';

export function mapToImmutable(detail) {
  return new Map({
    id: detail.id,
    name: detail.name,
    departmentId: detail.department_id,
  });
}

export function mapApiResponse(response) {
  return response.map(mapToImmutable);
}



// WEBPACK FOOTER //
// ./src/store/shiftDetails/lib.js